import React, { Component, Fragment } from "react";
//import Table from "../../Resources/Forms/Table";
import axios from "axios";
// import {
// 	BoxIcon,
// 	LeadTypesIcon,
// 	MapIcon,
// } from "../../Resources/Icons/Collections";
// import OrderProcessingItem from "./OrderProcessingItem";
// import OrderDetails from "./OrderDetails/OrderDetails";
import withAppData from "../../HOC/withAppData";
import { GET, POST } from "../../Utils/api";
import { _getLocationDistances } from "../../Utils/helpers";
import { google_key } from "../../app-config";
import {
	_cloneArray,
	_convertToSelectArray,
	_sortArray,
	_groupArray,
	_findArray,
	_validateNumber,
	_validatePhoneNumber,
	_cloneObject,
	_memoize,
	_capitalizeText,
	_compressImage,
	_uniqueArray,
	_getFromLocalStorage,
	_formatDate,
} from "../../Utils/helpers";
//import EmptyState from "../../Accounts/EmptyState";
import Input from "../../Resources/Forms/Input";
import Modal from "../Modal";
import TextArea from "../../Resources/Forms/TextArea";
import Button from "../../Resources/Forms/Button";
import InputButton from "../../Resources/Forms/InputButton";
import localForage from "localforage";
import InputDropdown from "../../Resources/Forms/InputDropdown";
import Avatar from "../../Resources/Avatar";
import Select from "../../Resources/Forms/Select";
import ReactSelect from "../../Resources/Forms/ReactSelect";
import DeliveryOtp from "./DeliveryOtp";
import ViewMore from "../../Resources/ViewMore";
import ConfirmModal from "../Plans/ConfirmModal";
import ExportOrders from "./ExportOrders";
import ChangeOrderStatus from "./ChangeOrderStatus";
// import MapContainer from "../Map/MapContainer";
// import { GoogleApiWrapper } from "google-maps-react";
// import { apiKey } from "../Map/helpers";
import DateFilter from "../../Resources/Forms/DateFilter";
import { nigeria_lgas, nigeria_states } from "../../Pipeline/StaticData";
//import Shipments from "./Shipments";
import ShipmentPrintData from "../Map/ShipmentPrintData";
//import OrderStatus from "./OrderStatus";
import { UserIsIdle } from "../../Utils/inActive";
import "../../Styles/Pages/orderprocessing.scss";
import { ClevertapAnalytics } from "../../Utils/ClevertapAnalytics";
// import CancelOrder from "./CancelOrder";
// import ReturnOrder from "./ReturnOrder";
import SuccessModal from "../../Pipeline/SuccessModal";
// import Loading from "../../Loaders/Loading";
let ApiKey = google_key;

const tableHeadings = [
	{
		text: "Order Id",
		width: 90,
	},
	{
		text: "SR Number",
		width: 90,
	},
	{ text: "Order date" },
	{ text: "Amount", width: 130 },
	{ text: "Customer" },
	{ text: "Source", width: 120 },
	{ text: "Assigned To" },
	{ text: "Status", width: 130 },
	{ text: "", width: 30 },
];

const today = ""; //dayjs().format("YYYY-MM-DD");   //stop today date filters

class OrderProcessing extends Component {
	constructor(props) {
		super(props);
		this.searchBoxRef = React.createRef();
		this.state = {
			verifdetails: [],
			geolong: 0,
			geolat: 0,
			currentAddress: "",
			allOrders: [],
			activeOrders: [],
			showLoader: true,
			searchValue: "",
			leadStages: [],
			showStatusChange: true,
			showConfirmStatus: false,
			changingOrderStage: false,
			stageChangeComment: "",
			assignTo: {},
			users: [],
			showUserAssign: true,
			activeOrder: "",
			assignOrderComment: "",
			assigningOrder: false,
			paymentReference: "",
			accountNumber: "",
			showFilter: false,
			filters: {
				status: "",
				agents: "",
				fromDate: "",
				toDate: "",
				source: "",
				takenBy: "",
				date: `${today},${today}`,
				isFirstOrder: 0,
			},
			filterCount: 0, //1 for applying today filter on load
			availableStatuses: [],
			products: [],
			checkedOrders: [],
			showCreatePackageList: false,
			sendDeliveryOtp: true,
			showOtpView: false,
			activeTab: "pending",
			tableHeadings: this.props.context.isOmsAdminBusiness
				? tableHeadings.filter(f => f.text !== "SR Number")
				: tableHeadings,
			view: "orders",
			allPackageLists: [],
			packageLists: [],
			showTopView: true,
			sliceValue: 10,
			soNumber: "",
			showAddress: true,
			isFinance: this.props.context.role.toLowerCase().includes("finance"),
			preventAssigningToSameUser: false,
			transactionId: "",
			ordersData: {},
			allUsers: [],
			orderSources: [
				{ name: "All", value: "" },
				//{ name: "Call Center", value: 1 },
				{ name: "OLD PWA", value: 2 },
				{ name: "WhatsApp", value: 3 },
				{ name: "RTO sales", value: 4 },
				{ name: "New PWA", value: 5 },
				{ name: "Android", value: 6 },
				{ name: "IOS", value: 7 },
				{ name: "BOT", value: 8 },
				{ name: "SYSTEM", value: 9 },
				{ name: "OMS", value: 11 },
				{ name: "Others", value: 10 },
			],
			orderSourceGroups: [
				{ name: "All", value: "" },
				{ name: "Call Center", value: 1 },
				{ name: "Scout", value: 2 },
			],
			newStatusId: 5,
			waybillNumber: "",
			orderTakers: [
				{ name: "All", value: "" },
				{ name: "Consumer", value: "0" },
				{ name: "Reseller", value: "1" },
			],
			ordersList: [],
			ordersTabs: [],
			searchingTimeout: 0,
			pageNumber: 1,
			created: { date: `${today},${today}`, state: "" },
			nigeriaStates: [],
			nigeriaLgas: [],
			warehouse: this.getWarehouse(),
			isMultipro: this.props.context.isMultiProBusiness,
			zones: [],
			defaultDateType: null,
			assignOrderPrm: {},
			updatepipelinePrm: {},
			updatePendingOrderPayementPrm: {},
			rtoDataPrm: {},
			showImageTagging: false,
			tempImageUrl: "",
			imageTagsGuides: [],
			imageTags: [],
			selectedImageTag: "",
			addedImages: [],
			customCustomerImageTags: [
				{
					ImageTypeID: 84,
					ImageTypeName: "inside Outlet",
					IsMandatory: 1,
					RandomRequiredTags: 0,
				},
				{
					ImageTypeID: 86,
					ImageTypeName: "Outlet Shelf",
					IsMandatory: 1,
					RandomRequiredTags: 0,
				},
				{
					ImageTypeID: 87,
					ImageTypeName: "Outside Outlet",
					IsMandatory: 1,
					RandomRequiredTags: 0,
				},
			],
			userIsIdle: false,
			deliveredData: {},
			deliveredSuccess: false,
			stockPointDetails: [],
			isOrderVerificationTeam: this.props.context.role
				.toLowerCase()
				.includes("order verification team"),
			stockPointId: "",
			retailerPhoneNumber: "",
			retailerPhoneNumberError: "",
			retailerStoreName: "",
			orderStatus: [
				{ name: "All", value: "" },
				{ name: "First Order", value: 1 },
			],
			payLaterChildOrderSR: 0,
			orderIsIdle: false,
			orderIsIdleBtn: false,
			countryData: _getFromLocalStorage("countryData"),
			showconfirmloc: false,
			showlocmodal: false,
			showconfirmmodal: false,
			deliveredFormData: {},
			rtoData: {},
			toOtpPage: false,
			orderAmount: "",
			cashAmount: "",
		};
		this.resetSearch = this.resetSearch.bind(this);
		this.getDeliveredData = this.getDeliveredData.bind(this);
	}
	initImageTags = tags => {
		let imageTags = _cloneArray(tags);
		_convertToSelectArray(imageTags, "ImageTypeName", "ImageTypeID");
		imageTags.unshift({ name: "Select Tag", value: "" });
		this.setState({ imageTags }, () => {
			let imageTagsGuides = [];
			let mandatoryTags = tags.filter(tag => {
				return tag.IsMandatory === 1;
			});
			if (mandatoryTags.length === 0) {
				let randomRequiredTags = tags[0].RandomRequiredTags;
				if (randomRequiredTags) {
					imageTagsGuides.push({
						text:
							randomRequiredTags === 1
								? `Upload at least <b>1</b> picture for any tag`
								: `Upload at least <b>1</b> picture for <b>${randomRequiredTags}</b> tags`,
						done: false,
						showError: false,
						count: 1,
						type: "random",
					});
				}
				this.setState({ imageTagsGuides }, () => { });
			} else {
				mandatoryTags.forEach(tag => {
					imageTagsGuides.push({
						text: `Upload at least <b>1</b> picture for <b>${tag.ImageTypeName}</b> tag`,
						done: false,
						showError: false,
						tag: tag.ImageTypeName,
						count: 1,
					});
				});
				this.setState({ imageTagsGuides }, () => { });
			}
		});
	};
	checkImageTags = async () => {
		return this.initImageTags(this.state.customCustomerImageTags);
	};
	addImages = (e, flag) => {
		if (e) {
			e.preventDefault();
		}
		if (flag === 0) {
			let tagCount = 0;
			this.state.addedImages.forEach(image => {
				if (Number(image.tagId) === Number(this.state.selectedImageTag)) {
					tagCount++;
				}
			});
			if (tagCount === 1) {
				this.props.context.showAlert(
					"Max of 1 imgaes allowed per tag",
					"error",
				);
				return;
			}
		}
		fetch(`${this.state.tempImageUrl}`)
			.then(res => res.blob())
			.then(blob => {
				if (blob) {
					if (blob.type.includes("image")) {
						let file = new File([blob], `${this.state.selectedImageTag}.jpg`);
						this.compressFile(file);
					}
				}
			})
			.catch(error => { });
	};

	rejectAddress = async () => {
		this.setState({ showconfirmloc: false });
		this.confirmSubmit();
		let data = {
			businessId: this.props.context.businessId,
			loginUserId: this.props.context.HeaderData.UserId,
			customerId: Number(this.state.activeOrder.Customerid),
			fullAddress: this.state.currentAddress,
			longitude: this.props.context.userLocation.longitude || "",
			latitude: this.props.context.userLocation.latitude || "",
			flag: 1,
			stageNo: 98,
		};
		await POST("addressbook/addlocationverification", data);
	};
	acceptAddress = async () => {
		this.setState({ showconfirmloc: false });
		this.confirmSubmit();
		let data = {
			businessId: this.props.context.businessId,
			loginUserId: this.props.context.HeaderData.UserId,
			customerId: Number(this.state.activeOrder.Customerid),
			fullAddress: this.state.currentAddress,
			longitude: this.props.context.userLocation.longitude || "",
			latitude: this.props.context.userLocation.latitude || "",
			stageNo: 3,
		};
		await POST("addressbook/addlocationverification", data);
	};
	compressFile = async file => {
		let addedImages = [...this.state.addedImages];
		let compressedFile = await _compressImage(
			file,
			200,
			this.state.selectedImageTag ? this.state.selectedImageTag + ".jpg" : "",
		);
		let tagName;
		if (
			_findArray(
				this.state.imageTags,
				"ImageTypeID",
				Number(this.state.selectedImageTag),
			)
		) {
			tagName = _findArray(
				this.state.imageTags,
				"ImageTypeID",
				Number(this.state.selectedImageTag),
			).ImageTypeName;
		} else {
			tagName = "";
		}
		addedImages.push({
			file: compressedFile,
			url: this.state.tempImageUrl,
			tagName,
			tagId:
				this.state.imageTags.length > 0
					? Number(this.state.selectedImageTag)
					: "",
		});
		this.setState({ addedImages }, () => {
			this.setState({
				showImageTagging: false,
				tempFile: "",
				tempImageUrl: "",
				selectedImageTag: "",
				pictureError: false,
			});
			this.updateImageGuideSteps();
		});
	};
	removeAddedImage = (i, image) => {
		let addedImages = [...this.state.addedImages];
		addedImages.splice(i, 1);
		this.setState({ addedImages }, () => {
			this.updateImageGuideSteps();
		});
	};
	updateImageGuideSteps = () => {
		let imageTagsGuides = _cloneArray(this.state.imageTagsGuides);
		if (imageTagsGuides.length > 0 && this.state.imageTags.length > 0) {
			imageTagsGuides.forEach(guide => {
				guide.showError = false;
			});
			let uniqueImageTags = _uniqueArray(
				_cloneArray(this.state.addedImages),
				"tagId",
			);

			if (imageTagsGuides.length > 0) {
				if (imageTagsGuides[0].type === "random") {
					imageTagsGuides.forEach(guide => {
						guide.done =
							uniqueImageTags.length >= imageTagsGuides[0].count ? true : false;
					});
					this.setState({ imageTagsGuides });
				} else {
					imageTagsGuides.forEach(guide => {
						if (_findArray(this.state.addedImages, "tagName", guide.tag)) {
							guide.done = true;
						} else {
							guide.done = false;
						}
					});
					this.setState({ imageTagsGuides }, () => { });
				}
			}
		}
	};

	listenToEvent = () => {
		this.setState({ userIsIdle: true });
	};

	sendOrderDetailToOmniPay = async ()=>{
		await POST(
			`OmniPay/CreateOmniPayOrderWithoutTransaction?orderId=${this.props.orderId}`,
		);
	}

	componentDidMount() {
		console.log("orderid-" + this.props.orderId);
		if(this.props.orderId)
		{
			this.sendOrderDetailToOmniPay();
		}
		// console.log("props", this.props.processtype)
		// console.log("gotten here....")
		this.getSingleOrder();
		//check if user has permission to view page
		// if (!this.props.context.hasPermission(159, 2)) {
		// 	this.props.history.replace("/");
		// } else {
		// this.applyOnLoadFilter();
		// this.listenToEvent();
		// //this.getOrders(1, 10, 1);
		// this.getUsers();
		// //this.setStatesAndLga();
		// this.checkImageTags();

		//refresh orders after 60 seconds to update screen if any order has been phonecall RTO'd
		// if (
		// 	this.props.history.location.pathname.includes(this.props.shipmentId)
		// ) {
		// this.refreshForRTOPhoneCall();
		// }

		// (this.state.isOrderVerificationTeam ||
		// 	this.props.context.role === "Admin") &&
		// 	this.getStockPoints();
		// }
	}

	buttonClick = () => {
		if (this.state.showAddress) {
			this.setState({ showlocmodal: false, showconfirmloc: true });
		} else {
			this.setState({ showlocmodal: false });
			this.confirmSubmit();
		}
	};

	refreshForRTOPhoneCall = async () => {
		// starting with this hub (Ifako) only
		await this.getSingleOrder();
		// if (this.props.context.businessId === 1646579) {
		// setTimeout(() => {
		// this.getOrders(1, 10, 1);
		// }, 60000);
		// }
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevState.showOrdersView !== this.state.showOrdersView) {
			if (this.state.showOrdersView) {
				this.setState({ tableHeadings });
			} else {
				this.setState(
					{
						tableHeadings: [
							{ text: "Created date" },
							{
								text: "Shipment Id",
							},
							{ text: "Number of orders" },
							{ text: "Assigned to" },
							{ text: "Status" },
							{ text: "", width: 30 },
						],
					},
					() => { },
				);
			}
			this.setState({ sliceValue: 10, searchValue: "" });
		}
		// if (
		// 	prevState.activeTab !== this.state.activeTab ||
		// 	prevState.activeOrders !== this.state.activeOrders
		// ) {
		// 	//this.createOrdersList();
		// }
	}
	getStockPoints = async () => {
		let orderId = this.props.context.isOmsAdminBusiness
			? this.state.activeOrder.Orderid
			: this.state.activeOrder.MasterOrderId;
		let result = await GET(`OrderManagement/GetHubList?Orderid=${this.props.orderId}`);
		if (result && result.length > 0) {
			let stockPointDetails = [{ name: "Select Stock Point", value: "" }];
			result.forEach((stock, i) => {
				stockPointDetails.push({
					name: stock.stockPointName,
					value: stock.stockPointId,
				});
			});
			await this.setState({ stockPointDetails: stockPointDetails });
		}
	};
	changeOrderStatusDeliverOffline = async CleverTapData => {
		const { longitude, latitude } = this.props.context.userLocation;
		let data = {
			NewStage: this.state.newStageName,
			PipelineId: this.state.activeOrder.Pipelineid,
			Note: "",
			CreatedBy: Number(this.props.context.userId),
			PipelineMasterId: 1,
			soNumber: this.state.activeOrder.SOnumber || "",
			OrionTransactionID: this.state.activeOrder.OrionTransactionID || "",
			waybillNumber: this.state.activeOrder.WaybillNumber || "",
			longitude: longitude || "",
			latitude: latitude || "",
		};
		this.setState({ orderIsIdleBtn: true });
		let result = await POST("pipeline/Updatepipeline", data);
		if (result.error) {
			if (result.error.errorCode === 7) {
				this.setState({
					orderIsIdle: true,
					orderIsIdleBtn: false,
					showOtpView: false,
					toOtpPage: false,
				});
				return;
			} else {
				this.setState({
					orderIsIdle: false,
					orderIsIdleBtn: false,
					showOtpView: false,
					toOtpPage: false,
				});
				this.props.context.showAlert(result.error.message, "error");
			}
		} else {
			this.setState({ showOtpView: false, toOtpPage: false });
			this.props.context.showAlert("Delivered offline successfully");
			CleverTapData &&
				CleverTapData.Customerid &&
				this.sendClevertapDeliveryEvent(CleverTapData);
			this.getOrders();
		}
		let RTOSalesData = {
			phone: this.state.retailerPhoneNumber,
			name: this.state.retailerStoreName,
			srNumber: this.state.activeOrder.Orderid,
			isPhoneVerified: 1,
		};
		await POST("OrderManagement/AddRTOSales", RTOSalesData);
		this.setState({
			retailerPhoneNumber: "",
			retailerStoreName: "",
		});
	};
	addRTOSales = e => {
		if (e) {
			e.preventDefault();
		}
		this.setState({
			showAddRTOSales: false,
			showOtpView: true,
		});
	};
	callOnepipeOrderAmountUpdate = async () => {
		let result = await GET(
			`payment/GetOrderDetailForOnePipe?orderId=${this.state.activeOrder.Orderid}`,
		);
		if (!result.error) {
			this.setState({
				showStatusChange: true,
				showConfirmStatus: false,
				loadingBtn: false,
			});
		}
	};
	confirmSubmit = async () => {
		// if (this.state.newStatusId === 5) {
		// 	this.callOnepipeOrderAmountUpdate();
		// }
		if (
			this.state.activeOrder.OrderStatusID === 224 ||
			this.state.activeOrder.OrderStatusID === 219
		) {
			this.setState({
				showStatusChange: true,
				showConfirmStatus: false,
				loadingBtn: false,
			});
		} else {
			if (this.state.newStatusId === 16) {
				this.setState({
					showAddRTOSales: true,
					showConfirmStatus: false,
				});
			} else {
				this.setState({ loadingBtn: true });
				let result = await GET(
					`OrderManagement/checkOrderReco?OrderId=${this.state.activeOrder.Orderid}`,
				);
				if (!result.error) {
					this.setState({
						showStatusChange: true,
						showConfirmStatus: false,
						loadingBtn: false,
					});
				} else {
					this.props.context.showAlert(result.error.type.message, "error");
					this.setState({ loadingBtn: false });
				}
			}
		}
	};
	render() {
		const { geolocationStatus } = this.props.context;
		const locationStatus =
			geolocationStatus === "granted"
				? "Enabled"
				: geolocationStatus === "denied"
					? "Blocked"
					: "Disabled";
		const showTopView =
			this.props.context.hasPermission(169, 3) ||
			this.props.context.hasPermission(170, 3) ||
			this.props.context.hasPermission(215, 3);

		const showMapViewPermission = this.props.context.hasPermission(215, 3);
		const canViewShipments = this.props.context.hasPermission(170, 3);

		const tabs = [
			{ name: "Pending", id: "pending", count: this.state.pendingOrders },
			{
				name: "Processed",
				id: "processed",
				count: this.state.processedOrders,
			},
			{ name: "All", id: "total", count: this.state.totalOrders },
		];

		return (
			<Fragment>
				{this.state.userIsIdle && <UserIsIdle duration={10} />}

				{!(this.state.activeOrder) ?
					<h2> loading </h2>
					: Number(this.props.processtype) == 1 ?
						<Modal
							header={"Confirm Push Order"}
							width={"400px"}
							maxHeight={"200px"}
							minHeight={"200px"}
							closeModal={() => {
								Interface.showToast('close_web_browser');
								GET(`Movam/SendCloseEventToMovam?orderId=${this.props.orderId}`,);
								window.location.reload();
							}}
						>
							<div className="modal-body">
								Are you sure you want to add all SKU within this order to
								inventory as part of a push sale?
							</div>

							<div className="modal-submit">
								<Button
									type={"primary"}
									text={"Yes, Push Order"}
									noMargin={true}
									onClick={() => {
										Interface.showToast('close_web_browser');
										GET(`Movam/SendCloseEventToMovam?orderId=${this.props.orderId}`,);
										window.location.reload();
									}}
								/>
								<Button
									type={"default"}
									noMargin={true}
									text={"Cancel"}
									onClick={() => {
										this.setState({ showStatusChange: false });
									}}
								/>
							</div>
						</Modal>
						: <ChangeOrderStatus
							order={this.state.activeOrder}
							users={this.state.users}
							close={() =>
								this.setState({
									// showStatusChange: false, 
									assignTo: {}
								})
							}
							showDeliveredSuccess={(data, show) => {
								this.setState(
									{
										orderAmount: data.orderAmount,
										cashAmount: data.cashAmount,
									},
									() =>
										this.setState({
											showStatusChange: false,
											deliveredSuccess: true,
										}),
								);
							}}
							deliveredData={this.getDeliveredData}
							newStageName={this.state.newStageName}
							newStatusId={this.state.newStatusId}
							showOtpView={() => this.setState({ showOtpView: true })}
							toOtpPage={() => this.setState({ toOtpPage: true })}
							getOrders={this.getOrders}
							preventAssigningToSameUser={
								this.state.preventAssigningToSameUser
							}
							getOrder={this.getSingleOrder}
							context={this.props.context}
							setPipelineFetchPrms={this.setPipelineFetchPrms}
							changeStatus={this.changeStatus}
							setShowImageTagging={(status, tempImageUrl, flag) => {
								this.setState(
									{
										showImageTagging: status,
										tempImageUrl: tempImageUrl,
									},
									() => {
										flag === 1 && this.addImages(null, 1);
									},
								);
							}}
							imageTagData={{
								selectedImageTag: this.state.selectedImageTag,
								imageTagsGuides: this.state.imageTagsGuides,
								addedImages: this.state.addedImages,
								imageTags: this.state.imageTags,
								removeAddedImage: this.removeAddedImage,
							}}
							getStockPoints={this.getStockPoints}
							stockPointDetails={this.state.stockPointDetails}
							sourceId={this.state.newStatusId}
							history={this.props.history}
						/>
				}
				{this.state.showImageTagging && (
					<Modal
						header={"Tag Image"}
						width={"400px"}
						isSmall={true}
						closeModal={() => this.setState({ showImageTagging: false })}
					>
						<div className="default-contact-image-tagging">
							<div className="default-contact-image-tagging-preview">
								<img src={this.state.tempImageUrl} alt="" />
							</div>
							<form
								className="default-contact-image-tagging-tag"
								onSubmit={e => this.addImages(e, 0)}
							>
								<Select
									label={"Select image tag"}
									value={this.state.selectedImageTag}
									options={this.state.imageTags}
									onChange={e =>
										this.setState({ selectedImageTag: e.target.value })
									}
									required={true}
									requiredStar={true}
								/>
								<div className="modal-submit">
									<Button type={"primary"} text={"Add Image"} noMargin={true} />
								</div>
							</form>
						</div>
					</Modal>
				)}
				{this.state.showAddRTOSales && (
					<Modal
						header={"Customer Details"}
						width={"400px"}
						isSmall={true}
						closeModal={() =>
							this.setState({
								showAddRTOSales: false,
								retailerPhoneNumber: "",
								retailerStoreName: "",
							})
						}
					>
						<div className="default-contact-image-tagging">
							<form
								className="default-contact-image-tagging-tag"
								onSubmit={e => this.addRTOSales(e)}
							>
								<Input
									label={"Retailer’s phone number"}
									value={this.state.retailerPhoneNumber}
									disabled={false}
									withMargin={true}
									required={true}
									requiredStar={true}
									placeholder="Enter retailer’s phone number i.e-08012345678"
									inputMode="numeric"
									pattern="\d*"
									maxLength={
										this.props.context.HeaderData.walletAmount.countryData
											.mobileLength
									}
									onKeyPress={e => _validateNumber(e, false)}
									onChange={e => {
										const value = e.target.value;
										this.setState({
											retailerPhoneNumber: value,
											retailerPhoneNumberError: _validatePhoneNumber(
												value,
												Number(
													this.props.context.HeaderData.walletAmount.countryData
														.mobileLength,
												),
											),
										});
									}}
									errorText={this.state.retailerPhoneNumberError}
								/>
								<Input
									label={"Store name"}
									value={this.state.retailerStoreName}
									disabled={false}
									withMargin={true}
									required={true}
									requiredStar={true}
									placeholder="Enter store name"
									onChange={e => {
										this.setState({ retailerStoreName: e.target.value || "" });
									}}
								/>
								<div className="modal-submit">
									<Button
										type={"primary"}
										text={"Proceed"}
										noMargin={true}
										disabled={
											!this.state.retailerPhoneNumber ||
											!this.state.retailerStoreName ||
											this.state.retailerPhoneNumberError
										}
									/>
								</div>
							</form>
						</div>
					</Modal>
				)}
				{this.state.showOrderAssign && (
					<Modal
						header={
							this.state.orderAssignFlag === 1
								? "Process Order"
								: this.state.orderAssignFlag === 2
									? "Confirm Order"
									: "Assign Order"
						}
						isSmall={true}
						width={"500px"}
						closeModal={() =>
							this.setState({
								showOrderAssign: false,
								assignTo: {},
								preventAssigningToSameUser: false,
								orderAssignFlag: 0,
								stockPointId: "",
								selectedStockPoint: {},
							})
						}
					>
						{this.props.context.role !== "Admin" &&
							this.state.users.length > 0 && (
								<Fragment>
									<div>
										{this.state.activeOrder.AgentName && (
											<Fragment>
												<div className="form__label">Assigned To</div>
												<div
													style={{ marginBottom: "15px" }}
													className="flex align-center"
												>
													<Avatar
														color={"#ffffff"}
														size={28}
														fontSize={"10px"}
														isRandomBg={true}
														name={this.state.activeOrder.AgentName}
													/>
													<span style={{ marginLeft: "7px" }}>
														{this.state.activeOrder.AgentName}
													</span>
												</div>
											</Fragment>
										)}
										{this.renderUserAssign(
											this.state.activeOrder.Agentid
												? this.state.users.filter(
													user =>
														user.Userid !== this.state.activeOrder.Agentid,
												)
												: this.state.users,
										)}
									</div>
								</Fragment>
							)}
						{this.state.stockPointDetails &&
							this.props.context.role === "Admin" && (
								<div style={{ paddingBottom: "50px" }}>
									<Select
										options={this.state.stockPointDetails}
										value={this.state.stockPointId}
										onChange={e => {
											this.selectedStockPoints(e);
										}}
										label={"Stock Point"}
										withMargin={true}
										required={true}
										requiredStar={true}
									/>
								</div>
							)}
						{this.props.context.role !== "Admin" &&
							!this.state.isFinance &&
							this.state.activeOrder.orderStatusId === 2 &&
							!this.state.activeOrder.SOnumber && (
								<Fragment>
									{!this.state.activeOrder.SOnumber && (
										<Input
											value={this.state.soNumber}
											onChange={e =>
												this.setState({ soNumber: e.target.value })
											}
											label={"SO Number"}
											required={true}
											requiredStar={true}
											withMargin={true}
											maxLength={10}
											type={"text"}
											inputMode="numeric"
											pattern="\d*"
											onKeyPress={e => _validateNumber(e, false)}
											errorText={
												this.state.soNumber && this.state.soNumber.length < 10
													? "Minimum of 10 digits"
													: ""
											}
										/>
									)}
								</Fragment>
							)}
						{this.props.context.role !== "Admin" && (
							<div style={{ paddingBottom: "70px" }}>
								<TextArea
									label={"Comment"}
									rows={"2"}
									value={this.state.assignOrderComment}
									onChange={e =>
										this.setState({ assignOrderComment: e.target.value })
									}
								/>
							</div>
						)}
						<div className="modal-submit">
							<Button
								type={"primary"}
								text={"Submit"}
								noMargin={true}
								loading={this.state.assigningOrder}
								onClick={() => {
									if (this.props.context.role === "Admin")
										this.reassignOrderVerificationStockPoint();
									else this.assignOrder();
								}}
								disabled={
									(this.state.users.length > 0 &&
										this.props.context.role !== "Admin" &&
										!this.state.assignTo.Userid) ||
									(this.props.context.role === "Admin" &&
										!this.state.stockPointId) ||
									(this.state.activeOrder.orderStatusId === 2 &&
										!this.state.isFinance &&
										this.props.context.role !== "Admin" &&
										(!this.state.soNumber || this.state.soNumber.length < 10) &&
										!this.state.activeOrder.SOnumber)
								}
							/>
						</div>
					</Modal>
				)}
				{this.state.showlocmodal && (
					<Modal
						closeModal={() => this.setState({ showlocmodal: false })}
						header={"Incorrect Location Warning"}
					>
						<div>
							<p
								className="bo-modal-body-header"
								style={{ justifyContent: "center", color: "red" }}
							>
								It looks like you are not in the following location:{" "}
								{this.state.currentAddress}. Would you like to proceed anyway?
							</p>
							<div className="Button-modal">
								<Button
									type="primary"
									text="Proceed anyway"
									onClick={() => this.buttonClick()}
								/>
							</div>
						</div>
					</Modal>
				)}
				{this.state.deliveredSuccess && (
					<SuccessModal
						close={() => {
							this.setState({
								deliveredSuccess: false,
							});
							this.getOrders();
						}}
						text={"Order Delivered Successfully"}
						subText={`${Number(this.state.cashAmount) >= Number(this.state.orderAmount)
							? ""
							: "Order Payment Received Successfully."
							}`}
						btnText={"Return to shipment"}
						btnType={"default"}
						btnAction={() => {
							this.setState({
								deliveredSuccess: false,
							});
							GET(`Movam/SendCloseEventToMovam?orderId=${this.props.orderId}`,);
							// this.getOrders();
							Interface.showToast('close_web_browser');
							window.location.reload();
						}}
						width={"300px"}
					/>
				)}
				{this.state.showConfirmStatus && this.state.showconfirmmodal && (
					<ConfirmModal
						close={() =>
							this.setState({
								showConfirmStatus: false,
								showconfirmmodal: false,
							})
						}
						header={`Are you sure you want to mark this order <span style="color:${[5, 16].includes(this.state.newStatusId) ? "green" : "red"
							}">${this.state.newStatusId === 5
								? "Delivered"
								: this.state.newStatusId === 16
									? "Resell RTO"
									: "RTO"
							}</span> ?
						<br/>
						${this.state.activeOrder.PaylaterChildOrderSRId !== 0 &&
								![5, 16].includes(this.state.newStatusId)
								? `This order has a related PayLater order- Order SR No: ${this.state.activeOrder.PaylaterChildOrderSRId}. <br/> This order also will automatically be marked RTO.`
								: ""
							}
						`}
						confirm={() => {
							this.confirmSubmit();
						}}
						loading={this.state.loadingBtn}
						confirmText={"Yes"}
						cancelText={"No"}
					/>
				)}
				{this.state.showconfirmloc && this.state.showAddress && (
					<>
						<ConfirmModal
							close={() => {
								this.setState({ showconfirmloc: false });
							}}
							confirmText={"Reject and deliver"}
							cancelText={"Continue and deliver"}
							confirm={() => this.rejectAddress()}
							cancel={() => this.acceptAddress()}
							header={"Please choose to continue or reject the below address"}
						>
							{this.state.verifdetails.length !== 0 && (
								<>
									<div style={{ fontWeight: "bold" }}>
										Address verified at Stage:{" "}
										{
											this.state.verifdetails[
												this.state.verifdetails.length - 1
											].StageNo
										}{" "}
										on{" "}
										{
											this.state.verifdetails[
												this.state.verifdetails.length - 1
											].EntryDate.split(" ")[0]
										}
									</div>
									<div
										className="table"
										style={{ paddingTop: "10px", paddingBottom: "10px" }}
									>
										<table
											style={{
												borderWidth: "1px",
												borderColor: "#aaaaaa",
												borderStyle: "solid",
												width: "100%",
											}}
										>
											<tr>
												<th>Agent</th>
												<th>Entry Date</th>
												<th>Stage Name</th>
											</tr>
											{this.state.verifdetails.map((val, key) => {
												return (
													<tr style={{ textAlign: "center" }} key={key}>
														<td>{val.AgentName}</td>
														<td>{val.EntryDate.split(" ")[0]}</td>
														<td>{val.StageName}</td>
													</tr>
												);
											})}
										</table>
									</div>
								</>
							)}
							<TextArea
								value={this.state.currentAddress}
								onChange={() => null}
								withMargin={true}
								label={"Full Address"}
								disabled
							/>
							<div className="Button-modal"></div>
						</ConfirmModal>
					</>
				)}
				{this.state.showConfirmModal && (
					<ConfirmModal
						close={() =>
							this.setState({
								showConfirmModal: false,
								preventAssigningToSameUser: false,
							})
						}
						header={"Are you sure you want to reassign ?"}
						subHeader={`Reassigning this order will remove it from the shipment list of <b>${this.state.activeOrder.AgentName}</b>`}
						confirm={() =>
							this.setState(
								{ showOrderAssign: true, showConfirmModal: false },
								() => {
									this.getStockPoints();
								},
							)
						}
						confirmText={"Reassign"}
					/>
				)}
				{this.state.showFilter && (
					<Modal
						header={"Filter Orders"}
						closeModal={() => this.setState({ showFilter: false })}
						width={"500px"}
					>
						<div style={{ paddingBottom: "80px" }}>
							<DateFilter
								label={"Created Date"}
								updateDate={(date, state) =>
									this.setState({ created: { date, state } }, () => {
										this.updateFilters("date", date);
									})
								}
								state={this.state.created.state}
								dateType={this.state.defaultDateType}
								autoScrollCalendar
							/>
							{((this.props.context.role === "Admin" &&
								this.state.allUsers.length > 0) ||
								this.state.users.length > 0) && (
									<ReactSelect
										label={"Assigned to"}
										options={
											this.props.context.role === "Admin"
												? this.state.allUsers
												: this.state.users
										}
										value={this.state.filters.agents}
										isMulti={true}
										placeholder={"Select users"}
										onChange={user => this.updateFilters("agents", user)}
										emptyText={"No user found"}
										withMargin={true}
										zIndex={4}
									/>
								)}
							{this.state.leadStages.length > 0 && (
								<Fragment>
									<ReactSelect
										label={"Status"}
										options={this.state.leadStages}
										value={this.state.filters.status}
										isMulti={true}
										placeholder={"Select status"}
										onChange={status => this.updateFilters("status", status)}
										emptyText={"No status found"}
										withMargin={true}
										zIndex={3}
									/>
								</Fragment>
							)}
							{this.state.orderSources.length > 1 && (
								<Fragment>
									<Select
										label="Source"
										value={this.state.filters.source}
										withMargin={true}
										options={this.state.orderSources}
										onChange={e => {
											e.target.value &&
												e.target.value !== "" &&
												e.target.value === "11" &&
												this.updateFilters("sourceGroup", "0");
											this.updateFilters("source", e.target.value);
										}}
									/>
								</Fragment>
							)}
							{this.state.filters.source === "11" && (
								<Select
									label="Source Group"
									value={this.state.filters.sourceGroup}
									withMargin={true}
									options={this.state.orderSourceGroups}
									onChange={e =>
										this.updateFilters("sourceGroup", e.target.value)
									}
								/>
							)}
							{/* <Select
								label="Customer Type"
								value={this.state.filters.takenBy}
								withMargin={true}
								options={this.state.orderTakers}
								onChange={e => this.updateFilters("takenBy", e.target.value)}
							/> */}

							<Select
								label={`Order ${this.state.countryData.stateLabel}`}
								value={this.state.filters.stateId}
								withMargin={true}
								options={this.state.nigeriaStates}
								onChange={e => this.updateFilters("stateId", e.target.value)}
							/>
							{this.state.filters.stateId && (
								<Select
									label={`Order ${this.state.countryData.lgaLabel}`}
									value={this.state.filters.lga}
									withMargin={true}
									options={[
										...[{ name: "All", value: "" }],
										...this.state.nigeriaLgas.filter(
											el =>
												Number(el.stateId) ===
												Number(this.state.filters.stateId),
										),
									]}
									onChange={e => this.updateFilters("lga", e.target.value)}
								/>
							)}
							<Select
								label="Order Status"
								value={this.state.filters.isFirstOrder}
								withMargin={true}
								options={this.state.orderStatus}
								onChange={e =>
									this.updateFilters("isFirstOrder", Number(e.target.value))
								}
							/>
							<div className="modal-submit">
								<div style={{ marginRight: "15px" }}>
									<Button
										type={"default"}
										text={"Reset"}
										noMargin={true}
										onClick={() => this.resetFilter()}
									/>
								</div>
								<Button
									type={"primary"}
									text={"Apply"}
									noMargin={true}
									onClick={() => this.applyFilter()}
								/>
							</div>
						</div>
					</Modal>
				)}
				{this.state.showOtpView && (
					<div className="order-processing">
						<DeliveryOtp
							context={this.props.context}
							order={this.state.activeOrder}
							close={() =>
								this.setState({ showOtpView: false, toOtpPage: false }, () => {
									this.getOrders();
								})
							}
							showOtpView={this.state.showOtpView}
							otpVerifyConfirm={
								this.state.newStatusId === 5 &&
								this.state.toOtpPage &&
								"OmniPay/ReceiveOTPFromCustomerForOrder"
							}
							activeVerificationOption={
								this.state.newStatusId === 5 && !this.state.toOtpPage ? 5 : 1
							}
							successOtpVerify={this.successOtpVerify}
							source={
								// this.state.rtoDataPrm &&
								// this.state.rtoDataPrm.Flag &&
								this.state.newStatusId === 7
									? "RTO"
									: this.state.newStatusId === 16
										? "Resell RTO"
										: "Delivered"
							}
							sourceId={this.state.newStatusId}
							retailerPhoneNumber={this.state.retailerPhoneNumber}
							retailerStoreName={this.state.retailerStoreName}
							history={this.props.history}
							deliveredFormData={this.state.deliveredFormData}
							deliveredData={this.state.deliveredData}
						/>
					</div>
				)}

				{this.state.showCreatePackageList && (
					<ShipmentPrintData
						google={this.props.google}
						loaded={this.props.loaded}
						close={() =>
							this.setState({ showCreatePackageList: false, activeOrder: {} })
						}
						orders={this.state.allOrders.filter(
							order => order.orderStatusId === 3,
						)}
						activeOrder={this.state.activeOrder}
						getOrders={this.getOrders}
						isNew={true}
						users={this.state.users}
						leadStages={this.state.leadStages}
						warehouse={this.state.warehouse}
					/>
				)}
			</Fragment>
		);
	}
	setPipelineFetchPrms = async (
		assignOrderPrm,
		updatepipelinePrm,
		updatePendingOrderPayementPrm,
		rtoDataPrm,
		payLaterChildOrderSR,
	) => {
		this.setState({
			assignOrderPrm,
			updatepipelinePrm,
			updatePendingOrderPayementPrm,
			rtoDataPrm,
			payLaterChildOrderSR,
		});
	};
	sendClevertapDeliveryEvent = data => {
		if (data.source === "Delivered") {
			ClevertapAnalytics.logEvent("OMS_ORDER_DELIVERED", {
				Order_ID: data.OrderId,
				Customer_ID: data.Customerid,
				Type: data.Type,
			});
		} else if (data.source === "RTO") {
			ClevertapAnalytics.logEvent("OMS_ORDER_RTO", {
				Order_ID: data.OrderId,
				Customer_ID: data.Customerid,
				Type: data.Type,
			});
		} else if (data.source === "Resell RTO") {
			ClevertapAnalytics.logEvent("OMS_ORDER_RESELL_RTO", {
				Order_ID: data.OrderID,
				Customer_ID: data.Customerid,
				Type: data.Type,
			});
		}
	};

	successRTO = async () => {
		const { rtoReason, rtoReasons } = this.state.rtoData;
		let reason = rtoReasons.find(
			rto => Number(rto.value) === Number(rtoReason),
		);
		if (reason) {
			let rtoData = {
				orderid: this.state.activeOrder.Orderid,
				orderstatusid: 7,
				RTOReasonID: reason.value,
				RTOReason: reason.name,
				Flag: 1,
			};
			const rtoSent = await POST("Store/AddOrderRTOReasons", rtoData);
			if (!rtoSent.error) {
				const {
					longitude = "",
					latitude = "",
				} = this.props.context.userLocation;
				let data = {
					NewStage: "RTO",
					PipelineId: this.state.activeOrder.Pipelineid,
					Note: "",
					CreatedBy: Number(this.props.context.userId),
					PipelineMasterId: 1,
					soNumber: this.state.activeOrder.SOnumber || "",
					OrionTransactionID: this.state.activeOrder.OrionTransactionID || "",
					waybillNumber: this.state.activeOrder.WaybillNumber || "",
					longitude,
					latitude,
				};
				let result = await POST("pipeline/Updatepipeline", data);
				if (result.error) {
					this.props.context.showAlert(result.error.message, "error");
					this.setState({ loading: false });
				} else {
					this.props.context.showAlert("RTO successfull");
					this.setState({
						// showStatusChange: false,
						showOtpView: false,
						toOtpPage: false,
						assignTo: {},
					});
				}
			} else {
				this.props.context.showAlert(rtoSent.error.message, "error");
			}
			this.getOrders();
		}
	};
	pushSalesOrder = async () => {
		// const { longitude = "", latitude = "" } = this.props.context.userLocation;
		let data = {
			NewStage: "Push Sales",
			PipelineId: this.state.activeOrder.Pipelineid,
			Note: "",
			CreatedBy: Number(this.props.context.userId),
			PipelineMasterId: 1,
			soNumber: this.state.activeOrder.SOnumber || "",
			OrionTransactionID: this.state.activeOrder.OrionTransactionID || "",
			waybillNumber: this.state.activeOrder.WaybillNumber || "",
			longitude: "",
			latitude: "",
		};
		let result = await POST("pipeline/Updatepipeline", data);
		console.log("result", result)
		if (result.error) {
			this.props.context.showAlert(result.error.message, "error");
			Interface.showToast('close_web_browser');
			await GET(`Movam/SendCloseEventToMovam?orderId=${this.props.orderId}`,);
			window.location.reload();
		} else {
			this.props.context.showAlert("Push successful, Check Driver Inventory");
			Interface.showToast('close_web_browser');
			await GET(`Movam/SendCloseEventToMovam?orderId=${this.props.orderId}`,);
			window.location.reload();
		}
		this.getOrders();
	};

	successOtpVerify = async CleverTapData => {
		CleverTapData &&
			CleverTapData.Customerid &&
			ClevertapAnalytics.onUserLogin(
				CleverTapData.retailerName || "",
				CleverTapData.Customerid,
				`+${this.state.countryData.ISDCode}${CleverTapData.Phone}`,
			);
		//this.setState({ showOtpView: false });
		if (this.state.newStatusId === 16) {
			this.changeOrderStatusDeliverOffline(CleverTapData);
		} else if (this.state.newStatusId === 7) {
			await this.successRTO();
		} else if (this.state.newStatusId === 5 && !this.state.toOtpPage) {
			Interface.showToast('close_web_browser');
			await GET(`Movam/SendCloseEventToMovam?orderId=${this.props.orderId}`,);
			this.setState({
				// showStatusChange: false,
				showOtpView: false,
				toOtpPage: false,
				deliveredSuccess: true,
			});
			window.location.reload();
		} else if (this.state.newStatusId === 5) {
			Interface.showToast('close_web_browser');
			await GET(`Movam/SendCloseEventToMovam?orderId=${this.props.orderId}`,);
			this.setState({
				// showStatusChange: false,
				showOtpView: false,
				toOtpPage: false,
				deliveredSuccess: true,
			});
			window.location.reload();
		} else {
			if (this.state.assignOrderPrm) {
				await POST("pipeline/addPipeline", this.state.assignOrderPrm);
				this.setState({ showOtpView: false, toOtpPage: false });
			}
			if (this.state.updatepipelinePrm) {
				this.setState({ orderIsIdleBtn: true });
				const result = await POST(
					"pipeline/Updatepipeline",
					this.state.updatepipelinePrm,
				);
				if (this.state.updatepipelinePrm.flag === 1) {
					if (result.error) {
						if (result.error.errorCode === 7) {
							this.setState({
								orderIsIdle: true,
								orderIsIdleBtn: false,
								showOtpView: false,
								toOtpPage: false,
							});
							return;
						} else {
							this.setState({
								orderIsIdle: false,
								orderIsIdleBtn: false,
								showOtpView: false,
								toOtpPage: false,
							});
							this.props.context.showAlert(result.error.message, "error");
						}
					} else {
						this.setState({
							orderIsIdle: false,
							orderIsIdleBtn: false,
							showOtpView: false,
							toOtpPage: false,
						});
						// rto child paylater order if it exists
						CleverTapData &&
							CleverTapData.Customerid &&
							this.sendClevertapDeliveryEvent(CleverTapData);
						if (
							this.state.updatepipelinePrm.NewStage === "RTO" &&
							this.state.payLaterChildOrderSR !== 0
						) {
							this.rtoChildOrder(
								this.state.payLaterChildOrderSR,
								this.state.updatepipelinePrm,
							);
						}
						this.props.context.showAlert("Delivery acknowledged successfully");
					}
				} else {
					if (result.error) {
						if (result.error.errorCode === 7) {
							this.setState({
								orderIsIdle: true,
								orderIsIdleBtn: false,
								showOtpView: false,
								toOtpPage: false,
							});
							return;
						} else {
							this.setState({
								orderIsIdle: false,
								orderIsIdleBtn: false,
								showOtpView: false,
								toOtpPage: false,
							});
							this.props.context.showAlert(result.error.message, "error");
						}
					} else {
						this.setState({ showOtpView: false, toOtpPage: false });
						CleverTapData &&
							CleverTapData.Customerid &&
							this.sendClevertapDeliveryEvent(CleverTapData);
						// rto child paylater order if it exists
						if (
							this.state.updatepipelinePrm.NewStage === "RTO" &&
							this.state.payLaterChildOrderSR !== 0
						) {
							this.rtoChildOrder(
								this.state.payLaterChildOrderSR,
								this.state.updatepipelinePrm,
							);
						}
						this.props.context.showAlert("Delivery acknowledged successfully");
					}
				}
			} else {
				this.props.context.showAlert("Delivery acknowledged successfully");
				this.setState({ showOtpView: false, toOtpPage: false });
			}
			this.state.updatePendingOrderPayementPrm &&
				(await POST(
					"store/UpdatePendingOrderPayement",
					this.state.updatePendingOrderPayementPrm,
				));
			this.state.rtoDataPrm &&
				(await POST("Store/AddOrderRTOReasons", this.state.rtoDataPrm));

			// show delivered success modal
			this.getOrders();
		}
	};

	rtoChildOrder = async (orderId, parentRTOData) => {
		const { longitude = "", latitude = "" } = this.props.context.userLocation;
		let orderDetailTest = await GET(
			`Store/GetOnlineOrders_Retail_details?Orderid=${orderId}`,
		);
		const data = {
			stockPointId: parentRTOData.stockPointId || 0,
			NewStage: parentRTOData.NewStage,
			PipelineId: orderDetailTest.PipeLineId,
			Note: "Parent Order of this PayLater Order RTO",
			CreatedBy: Number(parentRTOData.CreatedBy),
			PipelineMasterId: 1,
			soNumber: orderDetailTest.SOnumber || "",
			OrionTransactionID: orderDetailTest.OrionTransactionID || "",
			waybillNumber: orderDetailTest.WaybillNumber || "",
			longitude,
			latitude,
			AssignToAgentID: parentRTOData.AssignToAgentID,
			flag: [5, 7].includes(orderDetailTest.orderStatusId) ? 1 : 0,
			rtoReason: "Parent Order of this PayLater Order RTO",
		};
		await POST("pipeline/Updatepipeline", data);
	};

	renderViewMoreOrders = () => {
		const activeTabState = `${this.state.activeTab}Orders`;
		return (
			this.state[activeTabState] > this.state.sliceValue && (
				<ViewMore
					load={() => this.loadMoreOrders()}
					loading={this.state.loadingMoreOrders}
				/>
			)
		);
	};

	createOrdersList = flag => {
		let activeOrders = _cloneArray(this.state.activeOrders);
		//const { activeTab } = this.state;
		// const pendingOrders = activeOrders.filter(el => !el.IsProcessed);
		// const processedOrders = activeOrders.filter(el => el.IsProcessed);
		let ordersList = activeOrders;
		// if (activeTab === "pending") {
		// 	ordersList = pendingOrders;
		// } else if (activeTab === "processed") {
		// 	ordersList = processedOrders;
		// } else {
		// 	ordersList = activeOrders;
		// }
		this.setState({
			ordersList,
			showLoader: false,
			loadingMoreOrders: false,
		});
	};

	updateCheckedOrders = id => {
		let checkedOrders = [...this.state.checkedOrders];
		let orderIndex = checkedOrders.indexOf(id);
		if (orderIndex > -1) {
			checkedOrders.splice(orderIndex, 1);
		} else {
			checkedOrders.push(id);
		}
		this.setState({ checkedOrders });
	};

	updateFilters = (name, value) => {
		this.setState(
			{
				filters: { ...this.state.filters, [name]: value },
			},
			() => {
				if (name === "stateId") {
					this.updateFilters("lga", "");
				}
			},
		);
	};

	sortOrders = field => {
		let id;
		if (field === "Order Id") {
			id = this.props.context.isOmsAdminBusiness ? "Orderid" : "MasterOrderId";
		} else if (field === "SR Number") {
			id = "Orderid";
		} else if (field === "Customer") {
			id = "CustomerName";
		} else if (field === "Status") {
			id = "OrderStatus";
		} else if (field === "Amount") {
			id = "TotalPrice";
		} else if (field === "Assigned To") {
			id = "AgentName";
		} else if (field === "Total Items") {
			id = "totalItems";
		} else if (field === "Order date") {
			id = "Createddate";
		} else if (field === "Source") {
			id = "OrderSource";
		}
		const currentOrders = _cloneArray(this.state.activeOrders);
		let activeOrders;
		if (id === this.state.activeSort) {
			this.setState(
				{
					isDescendingSort: !this.state.isDescendingSort,
				},
				() => {
					activeOrders = _sortArray(
						currentOrders,
						id,
						this.state.isDescendingSort,
					);
					this.setState({ activeOrders, activeSort: id });
				},
			);
		} else {
			this.setState(
				{
					isDescendingSort: false,
				},
				() => {
					activeOrders = _sortArray(currentOrders, id);
					this.setState({ activeOrders, activeSort: id });
				},
			);
		}
	};

	searchPackages = e => {
		let value = e.target.value;

		if (value) {
			value = value.toLowerCase();
		}

		let result = _cloneArray(this.state.allPackageLists);

		result = result.filter(order => {
			return (
				(order.assigned && order.assigned.toLowerCase().includes(value)) ||
				(order.packageId && order.packageId.toLowerCase().includes(value))
			);
		});
		this.setState({ packageLists: result });
	};

	loadMoreOrders = () => {
		//if (this.state.ordersList.length > this.state.sliceValue) {
		// if (this.state.ordersList.length - this.state.sliceValue <= 10) {
		// 	const activeTabState = `${this.state.activeTab}Orders`;
		// 	if (this.state[activeTabState] > this.state.ordersList.length) {
		// 		this.setState(
		// 			{ pageNumber: this.state.pageNumber + 1, loadingMoreOrders: true },
		// 			() => {
		// 				this.getOrders(3,10,(this.state.activeTab==="pending"?1:this.state.activeTab==="processed"?2:3))
		// 			},
		// 		);
		// 	}
		// }
		// this.setState({ sliceValue: this.state.sliceValue + 10 });
		this.setState(
			{
				pageNumber: this.state.pageNumber + 1,
				loadingMoreOrders: true,
				sliceValue: this.state.sliceValue + 10,
			},
			() => {
				this.getOrders(
					3,
					10,
					this.state.activeTab === "pending"
						? 1
						: this.state.activeTab === "processed"
							? 2
							: 3,
				);
			},
		);
		return;
		//}
	};

	getSingleOrder = async () => {
		try {
			let requestUrl = `store/GetOnlineOrders_Retail_details?orderId=${this.props.orderId}`;
			let result = await GET(requestUrl);
			if (result) {
				result['orderId'] = this.props.orderId
				result['Orderid'] = this.props.orderId
				this.setState({ activeOrder: result })
			}
		} catch (error) {
			console.log("active order error", error)
		}
	};

	getOrders = async (flag, count = 10, tabFlag = 1) => {
		/*
	  api call was made on page load if flag is 1
	  api call was made for exporting orders if flag is 2
	  now we are using flag=2 for download excel files via old apis
	*/
		let orders = [];
		let pageNumber = flag ? this.state.pageNumber : 1;
		try {
			// if (flag !== 1) {
			// 	if (this.state.pageNumber === 1 && flag !== 2) {
			// 		this.setState({ showLoader: true });
			// 	}
			// }
			if (flag === 1 && pageNumber === 1) {
				this.setState({ showLoader: true });
			}

			let requestUrl = `store/${flag === 2 ? "GetOnlineOrders_excel_download" : "GetOnlineOrders_Retail"
				}?IsCustomer=0&pageNo=${pageNumber}&recordPerPage=${count || 10
				}&shipmentId=${this.props.shipmentId || ""}&flag=${tabFlag}`;
			let filterQuery = "";
			if (this.state.filterCount > 0) {
				filterQuery = this.createFilterQuery();
				if (filterQuery.length > 0) requestUrl = `${requestUrl}&${filterQuery}`;
			}
			if (this.state.searchValue) {
				requestUrl = `${requestUrl}&search=${this.state.searchValue}`;
			}

			let leadStages =
				this.state.leadStages.length > 0
					? this.state.leadStages
					: await this.getLeadStages();
			if (leadStages.length) {
				_convertToSelectArray(leadStages, "PipeLineStage", "PipelineStageID");
				this.setState({ leadStages });
			}
			let result = await GET(requestUrl);

			if (result && result.error) {
			} else {
				console.log("flag", flag)
				if (flag !== 2) {
					if (
						result.TotalCount &&
						result.TotalCount.length &&
						pageNumber === 1
					) {
						const { Pending, Processed } = result.TotalCount[0];
						this.setState({
							pendingOrders: Pending || 0,
							processedOrders: Processed || 0,
							totalOrders: (Pending || 0) + (Processed || 0),
						});
					} else {
						if (!this.state.loadingMoreOrders) {
							this.setState({
								totalOrders: 0,
								pendingOrders: 0,
								processedOrders: 0,
							});
						} else {
							this.setState({ loadingMoreOrders: false });
						}
					}
				}

				if (result.OnlineOrder && result.OnlineOrder.length > 0) {
					// if (this.state.pageNumber !== 1 && !filterQuery) {
					// 	let onlineOrders = await localForage.getItem("onlineOrders");
					// 	if (onlineOrders && onlineOrders.orders && onlineOrders.count) {
					// 		orders = onlineOrders.orders.concat(result.OnlineOrder);
					// 	}
					// } else {
					console.log("order id", result.OnlineOrder)
					const singleOrder = result.OnlineOrder.filter((obj => obj.Orderid === this.props.orderId))
					this.setState({ activeOrder: singleOrder })
					let onlineOrdersFilters = await this.state.ordersList;
					if (pageNumber !== 1 && onlineOrdersFilters) {
						orders = onlineOrdersFilters.concat(result.OnlineOrder);
					} else {
						orders = result.OnlineOrder;
					}
					//}
					orders.forEach(el => {
						if (!el.ItemDetails) {
							el.ItemDetails = [];
						}
					});

					if (leadStages.length > 0) {
						/*
			  memoize function for getting order status id to prevent
			  recalculating order status id for already gotten id
			*/
						const memo = _memoize(this.getOrderStatusId);
						for (let order of orders) {
							order.totalItems = this.getTotalItems(order);
							order.orderStatusId = memo(leadStages, order.OrderStatus);
						}
					}

					// if (
					// 	orders.length > 0 &&
					// 	!filterQuery &&
					// 	!this.state.searchValue &&
					// 	flag !== 2
					// ) {
					// 	await localForage.setItem("onlineOrders", {
					// 		orders,
					// 		count: this.state.pageNumber===1?result.TotalCount[0]:this.state.totalOrders,
					// 	});
					// }
					if (flag !== 2) {
						await this.setState({
							allOrders: orders,
						});
						this.setState({ showDownload: this.state.allOrders.length > 0 });
						this.setState(
							// { activeOrders: _cloneArray(this.state.allOrders) },
							{ activeOrders: _cloneArray(orders) },
							() => {
								this.createOrdersList();
							},
						);
					}
				} else {
					if (!this.state.loadingMoreOrders) {
						if (flag !== 2) {
							this.setState({
								// totalOrders: 0,
								// pendingOrders: 0,
								// processedOrders: 0,
								allOrders: [],
								activeOrders: [],
								showDownload: false,
							});
						}
					} else {
						this.setState({ loadingMoreOrders: false });
					}
					this.setState({ showLoader: false });
				}
			}
		} catch (error) { }
		this.setState({
			activeTab:
				tabFlag === 1 ? "pending" : tabFlag === 2 ? "processed" : "total",
			pageNumber: pageNumber,
			sourceGroup: this.state.filters && this.state.filters.sourceGroup,
		});
		return orders;
	};

	createFilterQuery = () => {
		let queryObject = _cloneObject(this.state.filters);
		if (queryObject.date) {
			queryObject.startDate = queryObject.date.split(",")[0];
			queryObject.endDate = queryObject.date.split(",")[1];
			delete queryObject["date"];
		}
		if (queryObject.agents && queryObject.agents.length) {
			queryObject.agentIds = queryObject.agents.map(el => el.value).toString();
			delete queryObject["agents"];
		}
		if (queryObject.status && queryObject.status.length) {
			queryObject.orderStatusIds = queryObject.status
				.map(el => el.value)
				.toString();
			delete queryObject["status"];
		}
		if (queryObject.promotionTypeName && queryObject.promotionTypeName.length) {
			queryObject.promotionTypeName = queryObject.promotionTypeName
				.map(el => el.value)
				.toString();
		}
		if (queryObject.takenBy) {
			queryObject.IsRetailer = Number(queryObject.takenBy);
			delete queryObject["takenBy"];
		}
		if (queryObject.lga) {
			queryObject.cityName = _findArray(
				this.state.nigeriaLgas,
				"value",
				queryObject.lga,
			).text;
			delete queryObject["lga"];
		}
		if (queryObject.zone && queryObject.zone.length) {
			queryObject.zoneIds = queryObject.zone.map(el => el.value).toString();
			delete queryObject["zone"];
		}
		Object.keys(queryObject).forEach(
			key =>
				[null, undefined, ""].includes(queryObject[key]) &&
				delete queryObject[key],
		);
		return Object.keys(queryObject)
			.map(key => key + "=" + queryObject[key])
			.join("&");
	};

	getOrderStatusId = (leadStages, status) => {
		let leadStage = leadStages.find(
			stage =>
				stage.PipeLineStage &&
				stage.PipeLineStage.toLowerCase() === status.toLowerCase(),
		);
		if (leadStage) {
			return leadStage.Orderid;
		}
		return 0;
	};

	getTotalItems = order => {
		let totalItems = 0;
		if (!order.ItemDetails || order.ItemDetails.length === 0) {
			return totalItems;
		}
		order.ItemDetails.forEach(item => {
			if (item) {
				totalItems = totalItems + item.Quantity;
			}
		});

		return totalItems;
	};

	updateUsers = async (allUsers, updateLocalForage) => {
		const users = allUsers.filter(
			user => Number(user.ReportToUserID) === Number(this.props.context.userId),
		);
		this.setState({ allUsers, users });
		if (updateLocalForage) {
			await localForage.setItem("users", allUsers);
		}
	};

	getDeliveredData = (submitData, formData) => {
		this.setState(prevState => ({
			...prevState,
			deliveredData: submitData,
			deliveredFormData: formData,
		}));
	};

	getUsers = async () => {
		let users = await localForage.getItem("users");

		if (users) {
			_convertToSelectArray(users, "Username", "Userid");
			users.forEach((user, i) => {
				if (user.RoleName) {
					user.name = `${_capitalizeText(
						user.name,
					)}  ( ${user.RoleName.toLowerCase()} )`;
				}
			});
			await this.setState({ allUsers: users });
			users = users.filter(
				user =>
					Number(user.ReportToUserID) === Number(this.props.context.userId),
			);
			await this.setState({ users });
		}

		let result = await GET("roles/GetBusinessUserRole");
		if (
			result.UserRoles &&
			result.UserRoles.Userdetails &&
			result.UserRoles.Userdetails.length > 0
		) {
			users = result.UserRoles.Userdetails;
			await localForage.setItem("users", users);
			if (this.state.users.length > 0) {
				return;
			}
			_convertToSelectArray(users, "Username", "Userid");
			await this.setState({ allUsers: users });
			users.forEach((user, i) => {
				if (user.RoleName) {
					user.name = `${_capitalizeText(
						user.name,
					)}  ( ${user.RoleName.toLowerCase()} )`;
				}
			});
			users = users.filter(
				user =>
					Number(user.ReportToUserID) === Number(this.props.context.userId),
			);
			this.setState({ users });
		}
	};

	getLeadStages = async () => {
		let result = await GET(
			`pipeline/getBusinessLeadStages?pipelineMasterId=1&cacheId=${this.props.context.cacheId}`,
		);
		if (result.PipelineStates) {
			return result.PipelineStates;
		} else {
			return [];
		}
	};

	getgeocodedaddress = address => {
		const fullAddress = address;
		if (!fullAddress) {
			return;
		}
		// this.setState({ isGettingCoordinates: true });
		// cancel the previous request to prevent multiple api requests
		if (typeof this._source !== typeof undefined) {
			this._source.cancel("I just cancelled the previous request");
		}
		// save the new request for cancellation
		this._source = axios.CancelToken.source();
		const config = {
			cancelToken: this._source.token,
		};

		axios
			.get(
				`https://maps.googleapis.com/maps/api/geocode/json?address=${fullAddress
					.toLowerCase()
					.replace(/,/g, "+")}&key=${ApiKey}`,
				config,
			)
			.then(resp => {
				if (resp.data && resp.data.results) {
					const result = resp.data.results[0];
					const location = result.geometry.location;
					this.setState({
						geolong: location.lng,
						geolat: location.lat,
						// isGettingCoordinates: false,
					});
				}
			})
			.catch(error => {
				console.log("error");
			});
	};

	changeStatus = async (order, newStageName, newStatusId) => {
		let flag = false;
		if (order.PaylaterPrimaryOrderSRId !== 0) {
			let isPrimaryOrderDelivered = await GET(
				`/store/GetOrderDeliveryStatus?OrderId=${order.PaylaterPrimaryOrderSRId}`,
			);
			if (isPrimaryOrderDelivered.TotalCount === 0) {
				this.props.context.showAlert(
					`Please process this PayLater Order's parent order first. Order SR No: ${order.PaylaterPrimaryOrderSRId} `,
					"error",
				);
				return;
			}
		}

		let orderDetailTest = await GET(
			`Store/GetOnlineOrders_Retail_details?Orderid=${order.Orderid}`,
		);

		this.setState({ currentAddress: orderDetailTest.OrderLocation || "" });
		this.getgeocodedaddress(orderDetailTest.OrderLocation);

		if (newStatusId === 5) {
			await POST(
				`OmniPay/CreateOmniPayOrderWithoutTransaction?orderId=${order.Orderid}`,
			);
			// order.OrderSource.toLowerCase() == "call center" && await POST(`OmniPay/CreateOmniPayOrderWithoutTransaction?orderId=${order.Orderid}`);
			let result = await GET(
				`addressbook/getcustomerlocationverification?CustomerID=${order.Customerid}`,
			);
			if (!result.error) {
				if (result.length !== 0) {
					for (let i = 0; i < result.length; i++) {
						if (result[i].StageNo === 3) {
							this.setState({
								showAddress: false,
							});
						}
						if (result[i].StageNo === 2) {
							flag = true;
						}
					}
					if (!flag) {
						this.setState({
							showAddress: false,
						});
					}
					if (
						_getLocationDistances(
							Number(result[result.length - 1].Longitude),
							Number(result[result.length - 1].Latitude),
							this.props.context.userLocation.longitude,
							this.props.context.userLocation.latitude,
							"m",
						) > 250 &&
						result[result.length - 1].Latitude !== ""
					) {
						console.log("showing loc")
						this.setState({ showlocmodal: true });
					} else if (
						_getLocationDistances(
							this.state.geolong,
							this.state.geolat,
							this.props.context.userLocation.longitude,
							this.props.context.userLocation.latitude,
							"m",
						) > 250
					) {
						this.setState({ showlocmodal: true });
					} else {
						if (this.state.showAddress) {
							this.setState({ showconfirmloc: true });
						} else {
							this.confirmSubmit();
						}
					}
				} else {
					this.confirmSubmit();
				}
				this.setState({ verifdetails: result });
			} else {
				this.confirmSubmit();
			}
		}

		let customerdata = await GET(
			`addressBook/getContactAddress?customerId=${order.Customerid}`,
		);
		if (!customerdata.error) {
			if (customerdata.latitude === "" || customerdata.latitude === "0") {
				let customerData = {
					Customerid: customerdata.customerId,
					cityId: customerdata.cityId,
					flag: 2,
					fullAddress: customerdata.fullAddress,
					latitude: this.state.geolat.toString(),
					longitude: this.state.geolong.toString(),
					stateId: customerdata.stateId,
					streetName: customerdata.streetName,
					townId: customerdata.townId,
				};
				await POST("ADDRESSBOOK/CREATEADDRESS", customerData);
			}
		}

		this.setState({ activeOrder: order, newStageName, newStatusId }, () => {
			if ([7, 16].includes(newStatusId)) {
				// this.setState({ showConfirmStatus: true });
				this.confirmSubmit();
			} else {
				if (newStatusId !== 5) {
					this.setState({ showStatusChange: true });
				}
			}
		});
	};
	reassignOrderVerificationStockPoint = async () => {
		if (this.state.showOrderAssign) {
			this.setState({ assigningOrder: true });
		}
		let data = {
			OrderID: this.state.activeOrder.Orderid,
			stockPoint: this.state.stockPointId,
		};
		let result = await POST("store/ReassignOrderVerificationStockPoint", data);
		if (result.error) {
			this.setState({ assigningOrder: false });
			this.props.context.showAlert(result.error.message, "error");
		} else {
			this.props.context.showAlert(
				`Order assigned to ${this.state.selectedStockPoint.name} successfully`,
			);
			this.setState({
				assignTo: {},
				assigningOrder: false,
				showOrderAssign: false,
				assignOrderComment: "",
				soNumber: "",
				orderAssignFlag: 0,
				stockPointId: "",
				selectedStockPoint: {},
			});
			this.getOrders();
		}
	};
	assignOrder = async () => {
		if (this.state.showOrderAssign) {
			this.setState({ assigningOrder: true });
		}
		let data = {
			LeadId: this.state.activeOrder.leadid,
			PipelineId: this.state.activeOrder.Pipelineid,
			AgentId: this.state.assignTo.Userid,
			Type: 4,
			pipelineMasterId: 1,
			Note: this.state.assignOrderComment,
			soNumber: this.state.soNumber || this.state.activeOrder.SOnumber || "",
			OrionTransactionID:
				this.state.transactionId ||
				this.state.activeOrder.OrionTransactionID ||
				"",
		};

		let result = await POST("pipeline/addPipeline", data);
		if (this.state.showOrderAssign) {
			if (result.error) {
				this.setState({ assigningOrder: false });
				this.props.context.showAlert("Please try again", "error");
			} else {
				if (this.state.orderAssignFlag) {
					this.props.context.showAlert(
						this.state.orderAssignFlag === 1
							? "Order processed succcessfully"
							: "Order confirmed successfully",
					);
				} else {
					this.props.context.showAlert(
						`Order assigned to ${this.state.assignTo &&
							this.state.assignTo.name &&
							this.state.assignTo.name.includes("(")
							? this.state.assignTo.name.split(" (")[0]
							: this.state.assignTo
								? this.state.assignTo.name
								: ""
						} successfully`,
					);
				}
				this.setState({
					assignTo: {},
					assigningOrder: false,
					showOrderAssign: false,
					assignOrderComment: "",
					soNumber: "",
					orderAssignFlag: 0,
				});
				this.getOrders();
				if (
					this.state.preventAssigningToSameUser &&
					this.state.activeOrder.PackageListID &&
					this.state.activeOrder.orderStatusId === 3
				) {
					this.setState({ preventAssigningToSameUser: false }, () => {
						this.updatePackageLists();
					});
				}
			}
		} else {
			this.setState({ assignTo: {} });
		}
	};
	selectedStockPoints = e => {
		let selectedStockPoint = _findArray(
			this.state.stockPointDetails,
			"value",
			Number(e.target.value || 0),
		);
		this.setState({
			stockPointId: e.target.value,
			selectedStockPoint: selectedStockPoint,
			//confirmstockPoint: e.target.value ? true : false,
		});
	};

	showOrderAssign = (order, flag) => {
		this.setState({ orderAssignFlag: flag || 0 });
		if (order.PackageListID && order.orderStatusId === 3) {
			this.setState({
				activeOrder: order,
				showConfirmModal: true,
				preventAssigningToSameUser: true,
			});
		} else {
			if (
				order.orderStatusId === 2 &&
				this.state.isFinance &&
				Number(order.Agentid) !== Number(this.props.context.userId)
			) {
				this.setState({ preventAssigningToSameUser: true });
			}
			this.setState({ activeOrder: order, showOrderAssign: true }, () => {
				this.getStockPoints();
			});
		}
	};

	updatePackageLists = () => {
		try {
			let packageLists = _cloneArray(this.state.packageLists);
			let activePackageId = this.state.activeOrder.PackageListID;
			let packageToUpdateIds = _findArray(
				packageLists,
				"packageId",
				activePackageId,
			).list.map(el => el.Orderid);
			packageToUpdateIds = packageToUpdateIds.filter(
				id => id !== this.state.activeOrder.Orderid,
			);

			let data = {
				OrderIds: packageToUpdateIds.toString(),
				Flag: 2,
				PackageListId: activePackageId,
			};
			POST("store/AddOrderPackageList", data);
		} catch (error) { }
	};

	applyOnLoadFilter = async () => {
		let today = new Date();
		let priorDate = new Date(new Date().setDate(today.getDate() - 29));
		let endDate = _formatDate(today);
		let startDate = _formatDate(priorDate);
		this.setState(
			{
				filterCount: 1,
				defaultDateType: 5,
				activeTab: "total",
				onLoadFilter: 1,
				filters: {
					date: `${startDate},${endDate}`,
				},
			},
			() => {
				this.setState(
					{
						filterCount: 1,
						pageNumber: 1,
						appliedFilter: true,
						sliceValue: 10,
					},
					() => {
						this.setState({ showLoader: true, showFilter: false });
						this.getOrders(1, 10, 1);
					},
				);
			},
		);
	};

	applyFilter = async () => {
		this.setState(
			{
				filterCount: this.countFilters(),
				defaultDateType: null,
				activeTab: "total",
			},
			() => {
				this.setState(
					{
						filterCount: this.countFilters(),
						pageNumber: 1,
						appliedFilter: true,
						sliceValue: 10,
					},
					() => {
						this.setState({ showLoader: true, showFilter: false });
						this.getOrders(0, 10, 3);
					},
				);
			},
		);
	};

	resetFilter = () => {
		this.setState(
			{
				filters: {},
				created: { date: "", state: "" },
			},
			() => {
				this.applyFilter();
			},
		);
	};

	countFilters = () => {
		let filters = { ...this.state.filters };
		return Object.values(filters).filter(
			val => val !== "" && val !== "," && val !== 0,
		).length;
	};

	getPackageCount = () => {
		let packageCount = 0;
		try {
			let allOrders =
				this.state.allOrders.length > 0
					? this.state.allOrders.filter(order => order.orderStatusId === 3)
					: [];
			if (allOrders.length === 0) {
				return 0;
			}
			if (allOrders.length === 0) {
				return 0;
			}
			let uniquePackageIds = Object.keys(
				_groupArray(allOrders, "PackageListID"),
			);

			packageCount = uniquePackageIds.filter(id => id).length;
		} catch (error) {
			packageCount = 0;
		}
		return packageCount;
	};

	setStatesAndLga = () => {
		let nigeriaStates = [
			...[{ name: "All", value: "" }],
			...nigeria_states.slice(1),
		];
		let nigeriaLgas = [
			...[{ name: "All", value: "" }],
			...nigeria_lgas.slice(1),
		];

		this.setState({ nigeriaStates, nigeriaLgas });
	};

	getOrdersToDownload = async () => {
		//if (this.state.totalOrders > this.state.activeOrders.length) {
		let orders = await this.getOrders(
			2,
			this.state.totalOrders > 10000 ? 10000 : this.state.totalOrders,
		);
		return orders;
		//}
		//return this.state.activeOrders;
	};

	renderUserAssign = users => {
		let dropdownUsers = users || this.state.users;
		if (this.state.preventAssigningToSameUser && this.state.activeOrder) {
			dropdownUsers = dropdownUsers.filter(
				user => user.Userid !== this.state.activeOrder.Agentid,
			);
		}
		return (
			<InputDropdown
				options={dropdownUsers}
				label={this.state.activeOrder.AgentName ? "Assign To" : "Assign To"}
				withMargin={true}
				isAbsolute
				selectOption={assignTo => {
					this.setState({ assignTo });
				}}
				splitName={true}
				requiredStar={true}
				errorText={
					this.state.preventAssigningToSameUser && dropdownUsers.length === 0
						? `Order can't be reassigned, ${this.state.activeOrder.AgentName} is the only user assigned to you`
						: ``
				}
				emptyText={"No user found"}
			/>
		);
	};
	showFullSearch = () => {
		this.setState(
			{
				showFullSearch: true,
			},
			() => {
				if (this.searchBoxRef.current) {
					this.searchBoxRef.current.focus();
				}
			},
		);
	};
	resetSearch = () => {
		if (this.searchBoxRef.current) this.searchBoxRef.current.value = "";
		if (this.state.hasChangedSearchValue) {
			this.setState(
				{
					showLoader: true,
					searchValue: "",
					pageNumber: 1,
					filterCount: 0,
					defaultDateType: null,
					filters: {},
					created: { date: "", state: "" },
				},
				() => {
					this.getOrders(1, 10, 1);
				},
			);
		}
		this.setState({
			showFullSearch: false,
			hasChangedSearchValue: false,
		});
	};
	renderSearch = () => {
		return (
			<InputButton
				placeholder={"Enter order Id or phone number"}
				buttonText={"Search"}
				maxLength={30}
				ref={this.searchBoxRef}
				onChange={e => {
					let value = e && e.target ? e.target.value : "";
					if (!this.state.hasChangedSearchValue) {
						this.setState({ hasChangedSearchValue: true });
					}
					this.setState({ searchValue: value });
				}}
				onClick={() =>
					this.setState(
						{
							pageNumber: 1,
							defaultDateType: null,
							filterCount: 0,
							filters: {},
							created: { date: "", state: "" },
						},
						() => this.getOrders(1, 10, 3),
					)
				}
				disableButton={!this.state.hasChangedSearchValue}
				loading={this.state.showLoader}
				hideInputLoading
			/>
		);
	};
	renderSearchAndFilter = () => {
		return (
			<Fragment>
				{window.screen.width >= 768 ? (
					!this.state.showFullSearch ? (
						<>
							<Button
								onClick={() =>
									this.setState({ showFilter: true }, () =>
										this.setStatesAndLga(),
									)
								}
								type={"link"}
								focus={true}
								noMargin={true}
							>
								<img src="Images/sort.svg" alt="" />
								<span className="show--desktop">Filter</span>
								{this.state.filterCount > 0 && (
									<p className="filter-count">{this.state.filterCount}</p>
								)}
							</Button>
							<ExportOrders
								BusinessId={this.props.context.HeaderData.BusinessId}
								getOrders={() => this.getOrdersToDownload()}
								show={
									this.state.showDownload &&
									this.props.context.hasPermission(249, 3)
								}
								users={this.state.users}
								context={this.props.context}
							/>
							<div
								className="address-book-body-btn"
								role="button"
								onClick={() => this.showFullSearch()}
								ref={this.searchBtnRef}
							>
								<span>
									<img src="Images/new-search.svg" alt="" />
								</span>
								<span className="show--desktop">Search</span>
							</div>
						</>
					) : (
						<div className="order-processing-header-filter-search2">
							{this.renderSearch()}
							<div
								className="order-processing-header-filter-search2-close"
								onClick={this.resetSearch}
							>
								&times;
							</div>
						</div>
					)
				) : (
					<div className="order-processing-header-filter-search2">
						{this.renderSearch()}
						{/* <div
							className={`flex align-center filter-orders ${
								this.state.filterCount > 0 ? "active" : ""
							}`}
							onClick={() =>
								this.setState({ showFilter: true }, () =>
									this.setStatesAndLga(),
								)
							}
						>
							<img src="Images/sort.svg" alt="" />
						</div> */}
					</div>
				)}
			</Fragment>
		);
	};

	getWarehouse = () => {
		const { userId, role } = this.props.context;
		const warehouses = [
			{
				name: "Lagos Warehouse",
				coords: { lat: 6.4820622, lng: 3.3541395 },
				address: "Plot 44, Jimoh Odutola Street, Surulere, Lagos, Nigeria",
			},
			{
				name: "Kaduna Warehouse",
				coords: { lat: 10.448795, lng: 7.4147693 },
				address: "Plot 9C, Industrial Area, Kakuri. Beside Peugeot, Kaduna",
			},
		];
		//multipro
		if (this.props.context.isMultiProBusiness) {
			if (role.toLowerCase().includes("packaging manager")) {
				if (Number(userId) === 1794157) {
					return warehouses[0];
				} else {
					return warehouses[1];
				}
			}
		}
		return warehouses[0];
	};
}

// export default GoogleApiWrapper({
// 	apiKey: apiKey,
// 	LoadingContainer: () => (
// 		<div className="order-processing">
// 			<div className="order-processing-header">
// 				<div className="orders-tab flex align-center">
// 					<TabsLoader />
// 				</div>
// 			</div>
// 			<Table headings={tableHeadings} showLoader={true}></Table>
// 		</div>
// 	),
// 	mapTypeControl: false,
// })(withAppData(OrderProcessing));


const TabsLoader = () => {
	return (
		<Fragment>
			{["Pending", "Processed", "All"].map((el, i) => (
				<div className={`orders-tab-each`} key={i}>
					{el}
					<span className="tab-count">
						<span className="loading-circle loading-circle-small"></span>
					</span>
				</div>
			))}
		</Fragment>
	);
};
export default withAppData(OrderProcessing);
